import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "fixed inset-0 z-10 overflow-y-auto" }
const _hoisted_2 = { class: "flex min-h-full items-center justify-center p-4 text-center sm:p-0" }
const _hoisted_3 = { class: "border border-gray-200 dark:border-gray-700 bg-white dark:bg-black px-4 pb-4 pt-5 sm:p-6 sm:pb-4" }
const _hoisted_4 = { class: "sm:flex sm:items-start" }
const _hoisted_5 = { class: "mt-3 text-center sm:ml-4 sm:mt-0 sm:text-left" }
const _hoisted_6 = { class: "mt-2" }
const _hoisted_7 = { class: "text-sm text-gray-500 dark:text-gray-400" }
const _hoisted_8 = { class: "font-semibold text-gray-900 dark:text-white" }
const _hoisted_9 = { class: "border border-gray-200 dark:border-gray-700 bg-gray-50 dark:bg-black px-4 py-3 sm:flex sm:flex-row-reverse sm:px-6 gap-3" }
const _hoisted_10 = ["disabled"]
const _hoisted_11 = { key: 0 }
const _hoisted_12 = {
  key: 1,
  class: "flex items-center"
}
const _hoisted_13 = ["disabled"]

import { Dialog, DialogPanel, DialogTitle, TransitionChild, TransitionRoot } from '@headlessui/vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'DeleteConfirmationModal',
  props: {
    isOpen: { type: Boolean },
    isLoading: { type: Boolean },
    entityName: {},
    entityType: {}
  },
  emits: ["close", "confirm"],
  setup(__props: any) {





return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(TransitionRoot), {
    show: _ctx.isOpen,
    as: "template"
  }, {
    default: _withCtx(() => [
      _createVNode(_unref(Dialog), {
        as: "div",
        class: "relative z-50",
        onClose: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('close')))
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(TransitionChild), {
            as: "template",
            enter: "ease-out duration-300",
            "enter-from": "opacity-0",
            "enter-to": "opacity-100",
            leave: "ease-in duration-200",
            "leave-from": "opacity-100",
            "leave-to": "opacity-0"
          }, {
            default: _withCtx(() => _cache[3] || (_cache[3] = [
              _createElementVNode("div", { class: "fixed inset-0 bg-black bg-opacity-50 transition-opacity" }, null, -1)
            ])),
            _: 1,
            __: [3]
          }),
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_unref(TransitionChild), {
                as: "template",
                enter: "ease-out duration-300",
                "enter-from": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95",
                "enter-to": "opacity-100 translate-y-0 sm:scale-100",
                leave: "ease-in duration-200",
                "leave-from": "opacity-100 translate-y-0 sm:scale-100",
                "leave-to": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(DialogPanel), { class: "relative transform rounded-lg bg-white dark:bg-black text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg" }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_3, [
                        _createElementVNode("div", _hoisted_4, [
                          _cache[6] || (_cache[6] = _createElementVNode("div", { class: "mx-auto flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-full bg-red-100 dark:bg-red-900/20 sm:mx-0 sm:h-10 sm:w-10" }, [
                            _createElementVNode("svg", {
                              class: "h-6 w-6 text-red-600 dark:text-red-400",
                              fill: "none",
                              viewBox: "0 0 24 24",
                              "stroke-width": "1.5",
                              stroke: "currentColor"
                            }, [
                              _createElementVNode("path", {
                                "stroke-linecap": "round",
                                "stroke-linejoin": "round",
                                d: "M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126zM12 15.75h.007v.008H12v-.008z"
                              })
                            ])
                          ], -1)),
                          _createElementVNode("div", _hoisted_5, [
                            _createVNode(_unref(DialogTitle), {
                              as: "h3",
                              class: "text-base font-semibold leading-6 text-gray-900 dark:text-white"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(" Delete " + _toDisplayString(_ctx.entityType), 1)
                              ]),
                              _: 1
                            }),
                            _createElementVNode("div", _hoisted_6, [
                              _createElementVNode("p", _hoisted_7, [
                                _cache[4] || (_cache[4] = _createTextVNode(" Are you sure you want to delete ")),
                                _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.entityName), 1),
                                _cache[5] || (_cache[5] = _createTextVNode("? This action cannot be undone. "))
                              ])
                            ])
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_9, [
                        _createElementVNode("button", {
                          type: "button",
                          disabled: _ctx.isLoading,
                          class: "inline-flex w-full justify-center rounded-md bg-red-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-red-500 sm:w-auto disabled:opacity-50 disabled:cursor-not-allowed transition-colors duration-200",
                          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('confirm')))
                        }, [
                          (!_ctx.isLoading)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_11, "Delete"))
                            : (_openBlock(), _createElementBlock("span", _hoisted_12, _cache[7] || (_cache[7] = [
                                _createElementVNode("svg", {
                                  class: "animate-spin -ml-1 mr-2 h-4 w-4 text-white",
                                  xmlns: "http://www.w3.org/2000/svg",
                                  fill: "none",
                                  viewBox: "0 0 24 24"
                                }, [
                                  _createElementVNode("circle", {
                                    class: "opacity-25",
                                    cx: "12",
                                    cy: "12",
                                    r: "10",
                                    stroke: "currentColor",
                                    "stroke-width": "4"
                                  }),
                                  _createElementVNode("path", {
                                    class: "opacity-75",
                                    fill: "currentColor",
                                    d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                                  })
                                ], -1),
                                _createTextVNode(" Deleting... ")
                              ])))
                        ], 8, _hoisted_10),
                        _createElementVNode("button", {
                          type: "button",
                          disabled: _ctx.isLoading,
                          class: "mt-3 inline-flex w-full justify-center rounded-md bg-white dark:bg-black px-3 py-2 text-sm font-semibold text-gray-900 dark:text-white shadow-sm ring-1 ring-inset ring-gray-300 dark:ring-gray-600 hover:bg-gray-50 dark:hover:bg-gray-600 sm:mt-0 sm:w-auto disabled:opacity-50 disabled:cursor-not-allowed transition-colors duration-200",
                          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('close')))
                        }, " Cancel ", 8, _hoisted_13)
                      ])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ])
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["show"]))
}
}

})